import React from 'react';
import "./index.css";
import img from "../../assests/dp.jpg";
import { FaAngleDoubleRight } from "react-icons/fa";

const About = () => {
  return (
    <>
      <section className='about-sec' id='about'>
        <div className='about-head'>
          <span>01.</span> About Me
        </div>

        {/* about div */}
        <div className='about-div'>
          {/* about */}
          <div className='about-details'>
            <p>
              Hello! My name is Prince and I enjoy creating things 
              that live on the internet. My interest in web development 
              started back in 2020 when I decided to make webite for my college project
              — turns out hacking into the web world, taught me a lot about HTML, CSS & JAVASCRIPT
            </p>
            <p>
              I'm currently working as a freelancer with a small freelancers group.
              Building MERN stack webpages for clients.
            </p>
            <p>
              I have also worked in <a rel='noreferrer' href='https://jungleworks.com/' target='_blank'> Jungleworks Pvt. Ltd.</a> as a Associate Node js developer Intern, 
              where I've worked on live projects in which I have worked on new features, 
              error fixing, debugging, deployment and clients interaction.
            </p>
            <p>
            My main focus these day is getting expert in full stack MERN application development.
            </p>
            <div className='skills'>
              <p>Here are a few technologies I've been working with recently:</p>
              <ul>
                <li><span className='skills-icon'><FaAngleDoubleRight/></span> JavaScript</li>
                <li><span className='skills-icon'><FaAngleDoubleRight/></span> React</li>
                <li><span className='skills-icon'><FaAngleDoubleRight/></span> Node</li>
                <li><span className='skills-icon'><FaAngleDoubleRight/></span> MySql/MongoDB</li>
                <li><span className='skills-icon'><FaAngleDoubleRight/></span> Solidity</li>
                <li><span className='skills-icon'><FaAngleDoubleRight/></span> Web3.js</li>
              </ul>
            </div>
          </div>
          {/* img */}
          <div className='about-img'>
            <div className='img-wrapper'>
              <div className='img-tag'>
                <img src={img} alt='profile-img'/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default About;